import Amazon from '../../../public/assets/amazon.webp'
import BB from '../../../public/assets/bigbasket.webp'
import MG from '../../../public/assets/magenta.webp'
import fK from '../../../public/assets/flipkart.webp'
import fyn from '../../../public/assets/fyn.webp'
import rapido from '../../../public/assets/rapido.webp'
import zepto from '../../../public/assets/zepto.webp'
import swiggy from '../../../public/assets/swiggy.webp'
import zm from '../../../public/assets/zomato.webp'
import tally from '../../../public/assets/tally.webp'
import Image from 'next/image'
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined'

function CompaniesDesktop() {
  let data = [
    {
      id: 1,
      image: Amazon,
      name: 'amazon',
      width: 138,
      height: 41
    },
    {
      id: 2,
      image: BB,
      name: 'bb',
      width: 170,
      height: 40
    },
    {
      id: 3,
      image: MG,
      name: 'mg',
      width: 182,
      height: 28
    },
    {
      id: 4,
      image: fK,
      name: 'fk',
      width: 200,
      height: 60
    },
    {
      id: 5,
      image: fyn,
      name: 'fyn',
      width: 92,
      height: 53
    },
    {
      id: 6,
      image: rapido,
      name: 'rapido',
      width: 110,
      height: 66
    },
    {
      id: 7,
      image: zepto,
      name: 'zepto',
      width: 118,
      height: 39
    },
    {
      id: 8,
      image: swiggy,
      name: 'swiggy',
      width: 174,
      height: 52
    },
    {
      id: 9,
      image: zm,
      name: 'zm',
      width: 142,
      height: 32
    },
    {
      id: 10,
      image: tally,
      name: 'tally',
      width: 80,
      height: 44
    }
  ]
  return (
    <div id="companies" className="px-[70px]">
      <div className="text-left font-noto-sans text-[48px] font-[600] text-greyTitleBase900">
        Find jobs from top companies
      </div>
      <div className="mt-[66px] grid grid-cols-2 items-center gap-[29px] md:grid md:grid-cols-5">
        {data.map((item,index) => {
          if (item.name === 'rapido') {
            return <Image key={index} src={item.image.src} width={item.width} height={item.height} className='relative bottom-[12px]'/>
          }
          else{
            return <Image key={index} src={item.image.src} width={item.width} height={item.height} />
          }
        })}
      </div>
      <div className="pt-[30px] text-center font-noto-sans text-[24px] font-[400] leading-[15px] text-greyTertiaryBase500">
        and many more
      </div>
      <div id="count" className="mt-[88px] flex flex-wrap justify-center items-center gap-[20px]">
        <div
          id="recruiters"
          className="custom-gradient border-greyDisabledBackground50 flex sm:w-[100%] md:w-[360px] flex-col space-y-[29px] rounded-[24px] border-solid p-[32px]"
        >
          <DomainOutlinedIcon
            sx={{
              width: '56px',
              height: '56px',
              color: '#2286D9'
            }}
          />
          <div>
            <div className="text-left font-noto-sans text-[40px] font-[600] text-greyTitleBase900">
              350000+
            </div>
            <div className="text-left font-noto-sans text-[24px] text-greyTertiaryBase500">
              Recruiters
            </div>
          </div>
        </div>
        <div
          id="candidates"
          className="custom-gradient border-greyDisabledBackground50 flex sm:w-[100%] md:w-[360px] flex-col space-y-[29px] rounded-[24px] border-solid p-[32px]"
        >
          <PersonOutlinedIcon
            sx={{
              width: '56px',
              height: '56px',
              color: '#2286D9'
            }}
          />

          <div>
            <div className="text-left font-noto-sans text-[40px] font-[600] text-greyTitleBase900">
              5500000+
            </div>
            <div className="text-left font-noto-sans text-[24px] text-greyTertiaryBase500">
              Candidates
            </div>
          </div>
        </div>

        <div
          id="jobs-offered"
          className="custom-gradient  border-greyDisabledBackground50 flex sm:w-[100%] md:w-[360px] flex-col space-y-[29px] rounded-[24px] border-solid p-[32px]"
        >
          <HandshakeOutlinedIcon
            sx={{
              width: '56px',
              height: '56px',
              color: '#2286D9'
            }}
          />

          <div>
            <div className="text-left font-noto-sans text-[40px] font-[600] text-greyTitleBase900">
              750000+
            </div>
            <div className="text-left font-noto-sans text-[24px] text-greyTertiaryBase500">
              Jobs Offered
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default CompaniesDesktop
